import dayjs from 'dayjs';

import { formatEnglishDayMonth } from '@/common/utils/formatEnglishDateTime';

import { getDefaultMetricsDateRange } from './reportFilterDefaults';

function formatRangeEndpoint(iso: string, includeYear: boolean): string {
  if (includeYear) {
    return dayjs(iso).locale('en').format('D MMM YYYY');
  }
  return formatEnglishDayMonth(iso);
}

/** Formats a from–to span (e.g. "4 Aug – 2 Nov", year omitted when both dates share a year). */
export function formatMetricsDateRangeSpan(from: string, to: string): string {
  const sameYear = dayjs(from).year() === dayjs(to).year();
  const includeYear = !sameYear;
  return `${formatRangeEndpoint(from, includeYear)} – ${formatRangeEndpoint(to, includeYear)}`;
}

/** True when `from`/`to` match the cached default last-90-days window. */
export function isDefaultLast90DaysRange(from: string, to: string): boolean {
  const defaults = getDefaultMetricsDateRange();
  return from === defaults.from && to === defaults.to;
}

type DateRangeLabelT = (
  key: string,
  options?: { range: string; defaultValue?: string },
) => string;

/** Closed dropdown label for the report date range control. */
export function buildDateRangeClosedLabel(
  from: string,
  to: string,
  t: DateRangeLabelT,
  useLast90DaysPreset: boolean,
): string {
  const range = formatMetricsDateRangeSpan(from, to);
  if (useLast90DaysPreset) {
    return t('admin.reports.filters.dateRangeLast90Days', {
      range,
      defaultValue: 'Last 90 days · {{range}}',
    });
  }
  return t('admin.reports.filters.dateRangeCustom', {
    range,
    defaultValue: '{{range}}',
  });
}
